<template>
  <report-panel :anchor="anchor" :styling="'background-color:#c3d8d8;'">
    <div slot="title">Contact Details</div>
    <div slot="body">
      <table class="table table-striped" id="contact-details-table">
        <tbody>
          <tr>
            <th scope="row">Registered Address:</th>
            <td v-if="companyOverview.registeredaddress !== null && companyOverview.registeredaddress !== undefined">
              {{ companyOverview.registeredaddress.full }}
            </td>
            <td v-else>
              Not Available
              <span v-if="companyOverview.company_age_in_years < 1">
                - This could be because this is a new company.</span
              >
            </td>
          </tr>
          <!-- Because v-for has priority over v-if so we need to use a template  -->
          <!-- for the "not available" decision.. see https://vuejs.org/v2/guide/list.html -->
          <template
            v-if="
              companyOverview.telephonenumbers !== undefined &&
              companyOverview.telephonenumbers.length > 0
            "
          >
            <tr
              v-for="telephonenumber in companyOverview.telephonenumbers"
              :key="telephonenumber.id"
            >
              <th scope="row">Telephone:</th>
              <telephone-number :telephone-number="telephonenumber" />
            </tr>
          </template>
          <tr v-else>
            <th scope="row">Telephone:</th>
            <td>Not Available</td>
          </tr>
          <template v-if="companyOverview.primarywebsite">
            <tr>
              <th scope="row">Primary Website:</th>
              <td>
                <a v-bind:href="companyOverview.primarywebsite.url" target="_blank">
                  {{ dataOrError(companyOverview.primarywebsite.url) }}
                </a>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
      <div class="subtext">Data collected:&nbsp;{{ formatDate(companyOverview.created_at) }}</div>
    </div>
  </report-panel>
</template>

<script>
import GeneralTools from '@/mixins/GeneralTools';
import ReportPanel from '@/components/reports/components/ReportPanel';
import TelephoneNumber from '../../shared/TelephoneNumber';

export default {
  components: {
    ReportPanel,
    TelephoneNumber,
  },
  name: 'ContactDetails',
  mixins: [GeneralTools],
  props: {
    anchor: {
      default: null,
      required: false,
      type: String,
    },
    companyOverview: {
      required: true,
      type: Object,
    },
  },
};
</script>

<style scoped></style>
